<div class="w-full h-full">
  <!-- VIEWER -->
  <div id="viewer" class="w-full h-full">
    <dvm-map-viewer [service]="viewersService.viewer"></dvm-map-viewer>
  </div>
  
  <!-- MINIMAP -->
  <app-minimap></app-minimap>
  <!-- <div id="minimap" class="w-80 h-60 absolute bottom-0 left-0 z-[1] bg-amber-200" [class]="status.minimap.show ? 'pointer-events-auto' : 'opacity-0 pointer-events-none'">
    <dvm-navigable-minimap #minimapDom [linkedMapViewer]="viewersService.viewer"></dvm-navigable-minimap>
  </div> -->

  <!-- VIEWER 3D -->
  <div id="viewer3d" class="w-full h-full absolute top-0 left-0 z-[2] transition-opacity duration-500 ease-in-out" [class]="is3dView ? 'pointer-events-auto' : 'opacity-0 pointer-events-none'">
    <dvm-viewer3d [service]="viewersService.viewer3d">
      <app-vr-button [isCloseButton]="true" *ngIf="isVrView"></app-vr-button>
      <app-close-fullscreen-button></app-close-fullscreen-button>
    </dvm-viewer3d>
  </div>
</div>